
import { defineComponent } from 'vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import HeaderBar from '@/components/common/HeaderBar.vue';
import { otherCityList } from '@/utils/cities';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'FindBusOtherCity',
  components: {
    BaseLayout,
    HeaderBar,
  },
  setup() {
    const otherCities = otherCityList;
    const router = useRouter();
    const selectCity = (city: string) => {
      router.push(`/find-bus-route/${city}`);
    };
    return {
      otherCities,
      selectCity,
    }
  }
});
